import React, { useState, useEffect } from "react";

import { SkedIcon } from "ui";
import { PlatformIcon } from "entities/accounts";
import youtubeIconUtils from "utils/youtube-icon-utils";

const LINKED_PLATFORM = "LINKED";
const linkedPlatformObj = { NAME: LINKED_PLATFORM, TYPE: LINKED_PLATFORM };

const PlatformTabs = ({ platforms, onChange }) => {
  const [activePlatform, setActivePlatform] = useState(null);

  useEffect(() => {
    const platformObjs = platforms;
    let defaultPlatform = LINKED_PLATFORM;
    if (platformObjs.length === 1) {
      defaultPlatform = platformObjs[0].TYPE;
    }

    setActivePlatform(defaultPlatform);
    if (onChange) {
      onChange(defaultPlatform);
    }
  }, [platforms]);

  const handleChange = (type) => {
    setActivePlatform(type);
    if (onChange) {
      onChange(type);
    }
  };

  return (
    <ul className="p-0">
      {Object.keys(platforms).length > 1 && (
        <PlatformTab
          platform={linkedPlatformObj}
          active={activePlatform === LINKED_PLATFORM}
          onChange={handleChange}
        />
      )}
      {platforms.map((platform) => (
        <PlatformTab
          key={platform.NAME}
          platform={platform}
          active={activePlatform === platform.TYPE}
          onChange={handleChange}
        />
      ))}
    </ul>
  );
};

const PlatformTab = ({ platform, active, onChange }) => {
  const activeClasses = "bg-white border-r-0 border-r-white";
  const inactiveClasses = "bg-primary-200";
  const type = youtubeIconUtils.resolveYtRedIcon(platform.NAME);

  return (
    <li
      className={`flex items-center justify-center cursor-pointer mb-2 border border-solid rounded-l-lg w-40px h-40px p-4 border-primary-100 ${
        active ? activeClasses : inactiveClasses
      }`}
      onClick={() => onChange(platform.TYPE)}
    >
      {platform.NAME === LINKED_PLATFORM && (
        <SkedIcon icon="icon-link" className="font-bold text-primary-500" />
      )}
      {platform.NAME !== LINKED_PLATFORM && (
        <PlatformIcon css="width: 14px" type={type} />
      )}
    </li>
  );
};

export default PlatformTabs;
